module.exports = __webpack_public_path__ + "static/media/corporate-catering-1.b28b7958.jpg";